import React from "react"

export const CardTags = ({ article }) => {
  const { ressort, advertorial, is_exclusive, is_comment } = article
  const has_tags = advertorial?.is_advertorial > 0 || is_exclusive || is_comment

  if (has_tags) {
    return (
      <div className="my-2">
        <div className="tags">
          {advertorial?.is_advertorial > 0 && (
            <div className={`tag is-grey has-text-title-slim`}>Anzeige</div>
          )}
          {is_exclusive && (
            <div className={`tag is-${ressort} has-text-title`}>Exklusiv</div>
          )}
          {is_comment && (
            <div className={`tag is-${ressort} has-text-title`}>Kommentar</div>
          )}
        </div>
      </div>
    )
  } else {
    return null
  }
}
